export const COLUMN_MAPPING_STATUS_ACTION = {
  CONFIRMED: 0,
  EDIT: 1,
  IGNORED: 2,
};

export const COLUMN_MAPPING_STATUS = {
  MATCHED: 0,
  POSSIBLY_MATCHED: 1,
  NO_MATCH: 2,
  MANUAL_MATCH: 3
};
